import { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Nav, Table, Badge, Spinner, Dropdown } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";
import DropdownMenu from "./DropdownMenu";
import DocViewer from "./DocViewer";
import CqcContent from "./CqcContent";
import CqcAiChat from "./CqcAiChat";
import CqcAiCheckPanel from "./CqcAiCheckPanel";
import md5 from "md5";
import ChoosePlans from '../../components/application/ChoosePlans';

const CqcDashboard = (props) => {
  const { userData } = useContext(UserContext);
  const [data, setData] = useState(false);
  const [braUsers, setBraUsers] = useState(false);
  const [viewDoc, setViewDoc] = useState(false);
  const [contentready, setContentReady] = useState(false);
  const [udocs, setUDocs] = useState({
    doctypes: [],
    userdocs: [],
    userdocfiles: [],
    counts: [],
    bars: [],
  });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(0);
  const [SDate, setSDate] = useState(false);
  const [resources, setResources] = useState(false);
  const [ctype, setCType] = useState('content');
  const [udContent, setUDContent] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [assigned, setAssigned] = useState(false);
  const [assignedSearch, setAssignedSearch] = useState("");
  const [assUserTemp, setAssUserTemp] = useState([]);
  const [assigning, setAssigning] = useState(false);
  const [cal, setCal] = useState(false);
  const [loadres, setLoadres] = useState(false);
  const [showprof, setShowprof] = useState(true);
  const [cqcNote, showCQCNote] = useState(false);
  const [notes, setNotes] = useState([]);
  const [saveNote, setSaveNote] = useState(false);
  const [filter, setFilter] = useState({
    pp: 100,
    year: '',
    status: 0,
    st: 0,
    txt: "",
  });

  useEffect(() => {
    setContentReady(false);
    setUDContent(false);
  },[upload]);

  useEffect(() => {
    setAssignedSearch("");
    setAssUserTemp([]);
  }, [assigned]);

  const printContent = (title,content,print) => {
    const printWindow = window.open('', '', `fullscreen=yes`);
    printWindow.document.write('<html><head><title>' + title + '</title>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    if(print){
      printWindow.print();
    }
  };

  const fetchCQCNotes = () => {
    if (cqcNote !== false && _.isUndefined(cqcNote.loading)) {
      showCQCNote({ ...cqcNote, loading: true });
      axios
        .get(Utils.apiUrl(`cqcs/fetchnotes/${cqcNote.id}`), Utils.apiHeaders())
        .then((res) => {
          showCQCNote({ ...cqcNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(fetchCQCNotes, [cqcNote]);

  const saveCQCNote = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    const formData = new FormData(frm);
    if (_.isEmpty(frm.note.value)) {
      window.alert("Please fill notes to save");
      return false;
    }
    formData.append("cqcdoc_id", cqcNote.id);
    setSaveNote(true);
    axios
      .post(Utils.apiUrl(`cqcs/savenote`), formData, Utils.apiHeaders())
      .then((res) => {
        setSaveNote(false);
        showCQCNote(_.omit(cqcNote, ["notes", "loading"]));
      })
      .catch((err) => console.log(err));
  };

  const deleteNote = (nid) => {
    if (window.confirm("You are going to delete this note, continue?")) {
      setNotes(_.filter(notes, (n) => n.id !== nid));
      axios.delete(Utils.apiUrl(`cqcs/delnote/${nid}`), Utils.apiHeaders()).catch((err) => console.log(err));
    }
  };

  let cnt = 0;
  const years = [];
  const currentYear = new Date().getFullYear();
  const range = 20; // Change this value to adjust the range of selectable years
  for (let i = 2020; i <= currentYear + range; i++) {
    years.push(i);
  }

  const changestatus = (id, status) => {
    const postdata = `&id=${id}&status=${status}`;
    axios
      .post(Utils.apiUrl(`cqcs/savegapstatus`), postdata, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setUDocs((prevUdocs) => ({
            ...prevUdocs,
            userdocs: (prevUdocs?.userdocs || []).map((userdoc) => {
              if (parseInt(userdoc.id) === parseInt(id)) {
                const updatedRow = data.udf && data.udf[0] ? data.udf[0] : {};
                return { ...userdoc, ...updatedRow, gap_status: parseInt(status) };
              }
              return userdoc;
            }),
          }));
          setTimeout(() => {
            const el = document.getElementById(`cqc-doc-item-${id}`);
            if (el) {
              el.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
          }, 50);
          //console.log(udocs);
          // window.alert(res.data.message);
        } else {
          window.alert(_.isObject(data.message) ? Object.values(data.message).join(",") : data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const setYearValue = (e) => {
    setFilter({
      ...filter,
      st: 0,
      year: parseInt(e.currentTarget.value),
      status: 0,
    });
    setDType(0);
    // fetchCategory(e.currentTarget.value);
  };
  let stout = null;
  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
      setDType(0);
    }, 1000);
  };

  const addFilters = (start) => {
    let str = _.compact(_.map(filter, (fv, fk) => (fv !== "" ? `${fk}=${fv}` : undefined)));
    str.push(`st=${start}`);
    str.push(`profile=${data === false}`);
    str.push(`braUsers=${braUsers === false}`);
    return "?" + str.join("&");
  };

  const profileDetails = (start = 0) => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("cqcs/fetchprofile") + addFilters(start), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          if (_.get(data, "profile.id", false)) {
            setData(data.profile);
          }
          if (_.get(data, "braUsers", false)) {
            setBraUsers(data.braUsers);
          }

          setUDocs({
            doctypes: _.get(data, "doctypes", []) || [],
            userdocs: _.get(data, "userdocs", []) || [],
            userdocfiles: _.get(data, "userdocfiles", []) || [],
            counts: _.get(data, "counts", []) || [],
            bars: _.get(data, "bars[0]", _.get(data, "bars", {})),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(profileDetails, [filter]);

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    //== if selected year is previous year, then expiry date can be blank, else not allowed
    if (frm.exp_date && frm.exp_date.value === "" && parseInt(frm.year.value) !== (parseInt(new moment().format("YYYY"))-1)) {
      window.alert("Please select expiry date of the uploading document!");
      return false;
      //new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0];
    } else if (frm.exp_date && frm.exp_date.value !== "") {
      if(parseInt(new moment(frm.exp_date.value).format("YYYYMMDD")) < parseInt(new moment().format("YYYYMMDD"))){
        window.alert("Please select expiry date of today or later!");
        return false;
      }
    }

    setLoadres(parseInt(frm.udid.value));

    axios
      .post(Utils.apiUrl("cqcs/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        setLoadres(false);
        if (data.success && data.udf) {
          if (filter.status == 2 || filter.status == 3 || filter.status == 4) {
            setUpload(false);
          }
          const uploadedId = parseInt(data.udf.id);
          setUDocs((prevUdocs) => ({
            ...prevUdocs,
            userdocfiles: [
              ...prevUdocs.userdocfiles.filter((f) => parseInt(f.id) !== uploadedId),
              data.udf,
            ],
          }));

          if (frm.year && frm.year.value !== filter.year && filter.year !== "") {
            window.alert(`Document has been uploaded for the ${frm.year.value} you can view it by changing the year in filter option!`);
          }

          frm.reset();

          profileDetails(0);
          // window.alert(data.message);
        } else {
          window.alert(_.isObject(data.message) ? Object.values(data.message).join(",") : data.message);
        }
      })
      .catch((err) => {
        setLoadres(false);
        console.log(err);
      });
  };

  const deleteudf = (udf) => {
    if (window.confirm(`You are going to delete upload file ${udf.udoc}, continue?`)) {
      setLoadres(parseInt(udf.udid));
      axios
        .delete(Utils.apiUrl("cqcs/deleteudf/") + udf.id, Utils.apiHeaders())
        .then((res) => {
          setLoadres(false);
          const data = Utils.parseApiResponse(res);
          if (data.success) {
            setUDocs((prevUdocs) => {
              const tmp = [...prevUdocs.userdocfiles];
              _.remove(tmp, (udf1) => parseInt(udf1.id) === parseInt(udf.id));
              return { ...prevUdocs, userdocfiles: tmp };
            });
            profileDetails(0);
            // window.alert(data.message);
          } else {
            window.alert(_.isObject(data.message) ? Object.values(data.message).join(",") : data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const getColor = (doc) => {
    if (!doc || !doc.id) return "#070d59";
    const filteredData = (udocs.userdocfiles || []).filter((item) => parseInt(item.udid) === parseInt(doc.id));
    if (filteredData.length === 0) {
      return "#070d59";
    }
    // Get latest uploaded doc data
    const lastDoc = _.maxBy(filteredData, (item) => parseInt(item.id));
    if (!lastDoc) {
      return "#070d59";
    }

    if (parseInt(lastDoc.exp_status) === 1) {
      return "#ec5353";
    }
    if (parseInt(lastDoc.exp_soon_status) === 1) {
      return "#FFBF00";
    }
    return "green";
  };

  const getAssignedCount = (doc) => {
    if (!doc || !doc.assignedUsers) return 0;
    const rawIds = String(doc.assignedUsers).split(",").map((s) => s.trim()).filter(Boolean);
    if (rawIds.length === 0) return 0;
    if (braUsers && braUsers.length > 0) {
      const validIds = new Set(braUsers.map((u) => String(u.id)));
      return rawIds.filter((id) => validIds.has(String(id))).length;
    }
    return rawIds.length;
  };

  const renderDocTypes = () => {
    return (
      <div className="mt-0">
        <Row className="mb-3">
          <Col sm="12">
            <div className="d-flex flex-wrap align-items-center p-3 rounded-3" style={{ backgroundColor: '#f0f9ff', border: '1px solid #e0f2fe', color: '#0369a1' }}>
              <span className="fw-bold me-3" style={{ fontSize: '13px' }}>
                <i className="bi bi-lightbulb me-2" style={{ fontSize: '14px' }}></i>For Best Practice we recommend completing the documents marked as:
              </span>
              <div className="d-flex align-items-center mt-2 mt-sm-0">
                <span className="badge text-white px-2 py-1 me-2" style={{ backgroundColor: '#ff3c00', fontSize: '11px', fontWeight: 'bold' }}>
                  {udocs.userdocs.filter((item) => parseInt(item.required) === 1).length} Mandatory
                </span>
                <span className="badge text-white px-2 py-1" style={{ backgroundColor: '#800080', fontSize: '11px', fontWeight: 'bold' }}>
                  {udocs.userdocs.filter((item) => parseInt(item.required) === 2).length} Highly Recommended
                </span>
              </div>
            </div>
          </Col>
        </Row>
        {/* Two-Column Responsive Layout */}
        <Row className="g-4 mb-4">
          {/* Left Column: Filter by Category */}
          <Col xs={12} lg={4}>
            <div className="p-3 bg-white rounded-3 shadow-sm border border-light h-100">
              <div className="d-flex flex-column gap-2">
                <span className="fw-bold text-muted small text-uppercase" style={{ letterSpacing: '0.5px', fontSize: '11px' }}>Filter by Category</span>
                <Dropdown onSelect={(val) => { setDType(parseInt(val)); setSDate(0); }} className="w-100">
                  <Dropdown.Toggle variant="info" className="w-100 text-start fw-bold text-white px-3 py-2.5 d-flex align-items-center justify-content-between" style={{ borderRadius: '8px', fontSize: '14px', backgroundColor: '#0ea5e9', border: 'none' }}>
                    <span>{dtype === 0 ? "Category (All)" : udocs.doctypes[dtype]}</span>
                    <i className="bi bi-chevron-down" style={{ fontSize: '12px' }}></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 shadow-lg border-light" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <Dropdown.Item eventKey={0}>Category (All)</Dropdown.Item>
                    {_.map(udocs.doctypes, (cat, catidx) => (
                      <Dropdown.Item key={catidx} eventKey={catidx}>
                        {cat}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </Col>

          {/* Right Column: Gap Analysis Status */}
          <Col xs={12} lg={8}>
            <div className="p-3 bg-white rounded-3 shadow-sm border border-light h-100">
              <div className="d-flex flex-column gap-2">
                <span className="fw-bold text-muted small text-uppercase" style={{ letterSpacing: '0.5px', fontSize: '11px' }}>Gap Analysis Status</span>
                <Nav variant="pills" activeKey={SDate} onSelect={(val) => setSDate(parseInt(val) === SDate ? 0 : parseInt(val))} className="d-flex flex-wrap gap-2 w-100">
                  {[
                    {
                      color: "#198754", // green
                      icon: "bi-check-circle-fill",
                      label: "Have This",
                      idx: 1,
                      count: udocs.userdocs.filter(
                        (item) => item.gap_status == 1 && (dtype == 0 || dtype == item.cat)
                      ).length
                    },
                    {
                      color: "#FFBF00", // yellow
                      icon: "bi-arrow-repeat",
                      label: "Working on it",
                      idx: 2,
                      count: udocs.userdocs.filter(
                        (item) => item.gap_status == 2 && (dtype == 0 || dtype == item.cat)
                      ).length
                    },
                    {
                      color: "#EC5353", // red
                      icon: "bi-x-circle-fill",
                      label: "Don't Have",
                      idx: 3,
                      count: udocs.userdocs.filter(
                        (item) => item.gap_status == 3 && (dtype == 0 || dtype == item.cat)
                      ).length
                    },
                    {
                      color: "#848484", // grey
                      icon: "bi-dash-circle-fill",
                      label: "N/A",
                      idx: 4,
                      count: udocs.userdocs.filter(
                        (item) => item.gap_status == 4 && (dtype == 0 || dtype == item.cat)
                      ).length
                    }
                  ].map((t) => {
                    const total = udocs.userdocs.filter(
                      (item) => (dtype == 0 || dtype == item.cat)
                    ).length;
                    const isActive = SDate === t.idx;
                    return (
                      <Nav.Item key={t.idx} className="flex-grow-1" style={{ minWidth: '140px' }}>
                        <Nav.Link
                          eventKey={t.idx}
                          className="px-2 py-2 fw-bold d-flex align-items-center justify-content-between w-100"
                          style={{
                            backgroundColor: isActive ? t.color : '#f8fafc',
                            color: isActive ? '#ffffff' : '#334155',
                            border: `1px solid ${isActive ? t.color : '#e2e8f0'}`,
                            borderRadius: '8px',
                            fontSize: '13px',
                            transition: 'all 0.15s ease',
                            cursor: 'pointer'
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <i className={`bi ${t.icon}`} style={{ color: isActive ? '#ffffff' : t.color, fontSize: '14px' }}></i>
                            <span style={{ whiteSpace: 'nowrap' }}>{t.label}</span>
                          </div>
                          <Badge 
                            className="px-2.5 py-1.5 ms-2"
                            style={{ 
                              backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : t.color, 
                              color: '#ffffff',
                              fontSize: '11px',
                              borderRadius: '6px'
                            }}
                          >
                            {t.count} / {total}
                          </Badge>
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })}
                </Nav>
              </div>
            </div>
          </Col>
        </Row>

        {/* Desktop View Table */}
        <div className="cqc-desktop-table">
          <Card style={{ borderRadius: '12px', border: 'none' }} className="shadow-sm">
            <Card.Body className="m-2">
              <Table responsive={true} hover>
                <thead>
                  <tr>
                    <th className="text-end" width="50">
                      ##
                    </th>
                    <th>DOCUMENT</th>
                    <th>RESOURCES</th>
                    <th>STATUS</th>
                    <th>AUDIT</th>
                    <th>ASSIGNED</th>
                    <th>GAP ANALYSIS</th>
                    <th>
                      <img src={`${process.env.PUBLIC_URL}/images/notes-d.png`} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {_.map(
                    _.filter(udocs.userdocs, (p) => (dtype == 0 || parseInt(p.cat) === parseInt(dtype)) && (!SDate || SDate == p.gap_status)),
                    (doc, idx) => {
                      let res = [];
                      try {
                        res = typeof doc.resources === "string" && doc.resources.trim() !== "" ? JSON.parse(doc.resources) : (Array.isArray(doc.resources) ? doc.resources : []);
                      } catch (e) {
                        res = [];
                      }
                      if (!res || typeof res !== "object") res = [];
                      res.contents = contentOfUDoc(doc);
                      return (
                        <tr key={doc.id} id={`cqc-doc-item-${doc.id}`}>
                          <td className="text-end">
                            <div
                              className={`badge text-yellow`}
                              style={{
                                backgroundColor: doc.required == 2 ? "#800080" : doc.required == 1 ? "#ff3c00" : "#0d6efd",
                              }}
                            >
                              {Utils.addZero((cnt += 1))}
                            </div>
                          </td>
                          <td>{dtype != 0 ? doc.title : doc.title + " (" + doc.cat_name + ")"}</td>
                          <td>
                            <Button type="button" variant="primary" onClick={() => setResources(res)} disabled={res.length === 0}>
                              View
                            </Button>
                          </td>
                          <td>
                            <Button
                              className="me-2 ms2"
                              type="button"
                              variant="contained"
                              style={{
                                backgroundColor: getColor(doc),
                                color: "white",
                              }}
                              onClick={() => setUpload(doc.id)}
                            >
                              {getColor(doc) == "#070d59" ? "Complete" : "Manage"}
                            </Button>
                          </td>
                          <td>
                            <Button
                              className="me-2 ms2 "
                              type="button"
                              variant="primary"
                              onClick={() => setTrail(doc.id)}
                              disabled={res.length === 0}
                            >
                              Trail
                            </Button>
                          </td>

                          <td>
                            {assigning === doc.id && (
                              <>
                                <Spinner animation="grow" variant="dark" /> Assigning..
                              </>
                            )}
                            {assigning !== doc.id && (
                              <Button
                                className="me-2 ms2 "
                                type="button"
                                variant="light"
                                onClick={() => setAssigned(doc.id)}
                                disabled={res.length === 0}
                              >
                                Assigned - {getAssignedCount(doc)}
                              </Button>
                            )}
                          </td>

                          <td>
                            <DropdownMenu key={doc.id} doc={doc} changestatus={changestatus} dtype={dtype} />
                          </td>
                          <td>
                            <img
                              src={`${process.env.PUBLIC_URL}/images/notes.png`}
                              className="clickable"
                              title={`Notes for ${doc.title}`}
                              onClick={() => showCQCNote(doc)}
                            />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>

        {/* Mobile View Card List */}
        <div className="cqc-mobile-cards d-block d-md-none">
          {_.map(
            _.filter(udocs.userdocs, (p) => (dtype == 0 || parseInt(p.cat) === parseInt(dtype)) && (!SDate || SDate == p.gap_status)),
            (doc, idx) => {
              let res = [];
              try {
                res = typeof doc.resources === "string" && doc.resources.trim() !== "" ? JSON.parse(doc.resources) : (Array.isArray(doc.resources) ? doc.resources : []);
              } catch (e) {
                res = [];
              }
              if (!res || typeof res !== "object") res = [];
              res.contents = contentOfUDoc(doc);
              
              const priorityClass = doc.required == 1 ? 'mandatory' : (doc.required == 2 ? 'recommended' : 'optional');
              const priorityLabel = doc.required == 1 ? 'Mandatory' : (doc.required == 2 ? 'Highly Recommended' : 'Optional');
              const priorityBg = doc.required == 1 ? '#ff3c00' : (doc.required == 2 ? '#800080' : '#0d6efd');

              return (
                <div key={doc.id} id={`cqc-doc-item-${doc.id}`} className={`cqc-card-mobile ${priorityClass}`} style={{
                  background: '#fff',
                  border: '1px solid #dee2e6',
                  borderRadius: '12px',
                  padding: '16px',
                  marginBottom: '16px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                  position: 'relative',
                  overflow: 'hidden',
                  borderLeft: `5px solid ${priorityBg}`
                }}>
                  {/* Header Row */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="badge text-white px-2 py-1" style={{ backgroundColor: priorityBg, fontSize: '10px', fontWeight: 'bold' }}>
                      {priorityLabel}
                    </span>
                    <span className="text-muted small">## {Utils.addZero(idx + 1)}</span>
                  </div>

                  {/* Title */}
                  <h5 className="fw-bold mb-1" style={{ fontSize: '14.5px', color: '#0f2d52', lineHeight: '1.4' }}>
                    {dtype != 0 ? doc.title : doc.title + " (" + doc.cat_name + ")"}
                  </h5>

                  <hr className="my-2" style={{ borderColor: '#e2e8f0' }} />

                  {/* Restructured Mobile Details & Actions */}
                  <div className="mt-3">
                    {/* Line 1: Main CTA (Manage/Complete) + Gap Analysis */}
                    <div className="d-flex align-items-center justify-content-between mb-3 gap-2">
                      {(() => {
                        const btnColor = getColor(doc) === 'green' ? '#198754' : getColor(doc);
                        return (
                          <Button
                            size="sm"
                            variant="contained"
                            className="text-white fw-bold px-3 py-1.5 flex-grow-1"
                            style={{
                              backgroundColor: btnColor,
                              color: 'white',
                              fontSize: '12.5px',
                              borderRadius: '6px',
                              border: 'none',
                              minHeight: '34px',
                              boxShadow: `0 4px 6px ${btnColor}33`
                            }}
                            onClick={() => setUpload(doc.id)}
                          >
                            {getColor(doc) == "#070d59" ? "Complete" : "Manage"}
                          </Button>
                        );
                      })()}
                      <div className="flex-shrink-0">
                        <DropdownMenu doc={doc} changestatus={changestatus} dtype={dtype} />
                      </div>
                    </div>

                    {/* Line 2: 2x2 Touch Grid (Resources, Trail, Notes, Assigned Users) aligned to desktop */}
                    <Row className="g-2 pt-2.5" style={{ borderTop: '1px solid #f1f5f9' }}>
                      <Col xs={6}>
                        <Button 
                          size="sm" 
                          variant="outline-primary" 
                          className="w-100 py-1.5 d-flex align-items-center justify-content-center gap-1.5 fw-bold" 
                          onClick={() => setResources(res)} 
                          disabled={res.length === 0} 
                          style={{ fontSize: '11px', minHeight: '32px' }}
                        >
                          Resources
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button 
                          size="sm" 
                          variant="primary" 
                          className="w-100 py-1.5 d-flex align-items-center justify-content-center gap-1.5 fw-bold" 
                          onClick={() => setTrail(doc.id)} 
                          disabled={res.length === 0} 
                          style={{ fontSize: '11px', minHeight: '32px' }}
                        >
                          Trail
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button 
                          size="sm" 
                          variant="outline-warning" 
                          className="w-100 py-1.5 d-flex align-items-center justify-content-center gap-1.5 fw-bold text-dark" 
                          onClick={() => showCQCNote(doc)} 
                          style={{ fontSize: '11px', minHeight: '32px', borderColor: '#ffc107' }}
                        >
                          Notes
                        </Button>
                      </Col>
                      <Col xs={6}>
                        {assigning === doc.id ? (
                          <div className="w-100 d-flex justify-content-center"><Spinner animation="grow" size="sm" /></div>
                        ) : (
                          <Button 
                            size="sm" 
                            variant="light" 
                            className="w-100 py-1.5 d-flex align-items-center justify-content-center gap-1.5 fw-bold" 
                            onClick={() => setAssigned(doc.id)} 
                            disabled={res.length === 0} 
                            style={{ border: '1px solid #dee2e6', fontSize: '11px', minHeight: '32px' }}
                          >
                            Assigned - {getAssignedCount(doc)}
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    );
  };

  const showResources = () => {
    return (
      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Resources</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {_.get(resources.files, "length", 0) > 0 &&<h3>Documents</h3>} */}
          <ol>
            {/* {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                <div className=""></div>
                <a href={Utils.apiUrl("users/downloadud") + "/" + r}>
                  {r}
                  <span className="float-end me-4"> <img className="me-2" src='images/download.png' /></span>
                </a>
                
              </li>
            ))} */}
            {_.map(resources.contents, (content) => {
              return <li key={content.id} className="py-1 ">
                <div className=" mb-1">
                  {content.title}
                  <img className="float-end mx-2 pb-1" src='images/download-d.png' />
                    {/*<a className="float-end" title="Download Content" target="_blank" href={Utils.apiUrl("cqcs/downloadcontent") + "/" + md5(userData.uid)+ "?cid=" + md5(content.id)}>
                      <img className="mx-2" src='images/download.png' />
                    </a>*/}
                    <span className="float-end clickable" title="View Content" style={{width: '20px'}}  onClick={() => setUDContent({...content,mode:'view',show:true})}>
                      {Utils.viewIcon()}
                    </span>
                    
                  {/*</a>*/}
                </div>
              </li>
            })}
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1 ">
                <div className=" mb-1 ">
                  <a className="float-end clickable"  href={Utils.apiUrl("cqcs/downloadud") + "/" + r}>
                    <img className="mx-2" src='images/download.png' />
                  </a>
                  {/*<a target="_blank" href={`${process.env.PUBLIC_URL}/cqc/docviewer/${r}`}>*/}
                    {r}
                    <span className="float-end" style={{width: '20px'}} onClick={() => setViewDoc(r)}>
                      {Utils.viewIcon()}
                    </span>
                  {/*</a>*/}
                </div>
              </li>
            ))}
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1 ">
                <div className=" mb-1">
                  <a href={r} target="_blank" className="">
                    {r}
                    <span className="float-end me-4">🔗 </span>
                  </a>
                </div>
              </li>
            ))}
          </ol>
          {/* {_.get(resources.links, "length", 0) > 0 &&<h3>Links</h3>} */}
          {/* <ol>
            
          </ol> */}
        </Modal.Body>
      </Modal>
    );
  };

  const showViewDoc = () => {
    return (
      <Modal show={true} fullscreen={true} dialogClassName="modal-fullscreen" onHide={() => setViewDoc(false)}>
        <Modal.Header closeButton>Resource: {viewDoc}</Modal.Header>
        <Modal.Body><DocViewer doc={viewDoc} /></Modal.Body>
      </Modal>);
  };

  const showUDContent = () => {

    return (
      <Modal show={true} size="fullscreen" onHide={() => setUDContent({...udContent, show:false})}>
        <Modal.Header closeButton>Content: {udContent.title}</Modal.Header>
        <Modal.Body><CqcContent {...udContent} onChange={(cont) => setUDContent({...udContent,content: cont})} /></Modal.Body>
        {udContent.mode==='edit' && <Modal.Footer><Button type="button" variant="primary" size="sm" onClick={() => {
          setContentReady(udContent.content);
          setUDContent({...udContent,show:false});
        }}>Save Content</Button></Modal.Footer>}
      </Modal>);
  };

  const contentOfUDoc = (ud) => {
    if(ud.contents){
      return ud.contents.split('^|^').map(udc => {
        udc = udc.split('^^');
        return {id:udc[0],title: udc[1]}
      });
    }else{
      return [];
    }
  };

  const showUpload = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(upload));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));
    let settings = {};
    try {
      settings = typeof ud[0]?.settings === "string" && ud[0]?.settings.trim() !== "" ? JSON.parse(ud[0].settings) : (ud[0]?.settings || {});
    } catch (e) {
      settings = {};
    }
    

    // let expired = moment().isAfter(udf[0].updated_at, "year");

    return (
      <Modal size="xl" fullscreen="md-down" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setUpload(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"> {ud[0].title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}

          {/* Document History Cards */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-secondary text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Document History</h6>
            {udf.length === 0 && (
              <Alert variant="light" className="text-center py-4 border border-light shadow-sm" style={{ borderRadius: '8px' }}>
                <span className="text-muted" style={{ fontSize: '13px' }}>No documents uploaded yet.</span>
              </Alert>
            )}
            <div className="d-flex flex-column gap-3">
              {_.map(udf, (r) => (
                <div key={r.id} className="p-3 bg-white rounded-3 shadow-sm border border-light position-relative" style={{ transition: 'box-shadow 0.15s ease' }}>
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
                    <div className="d-flex flex-column gap-1">
                      <div className="d-flex flex-wrap align-items-center gap-2">
                        <span className="fw-bold text-dark" style={{ fontSize: '14.5px' }}>
                          {r.udoc.replace('(AI Generated)', '').replace('(Scan Uploaded)', '').trim()}
                        </span>
                        {r.udoc.includes('(AI Generated)') && (
                          <Badge bg="success" style={{ fontSize: '10px' }}><i className="bi bi-star-fill me-1" style={{ fontSize: '9px' }}></i>AI Generated</Badge>
                        )}
                        {r.udoc.includes('(Scan Uploaded)') && (
                          <Badge bg="info" className="text-dark" style={{ fontSize: '10px' }}><i className="bi bi-star-fill me-1" style={{ fontSize: '9px' }}></i>AI Transcribed</Badge>
                        )}
                      </div>
                      
                      <div className="d-flex flex-wrap gap-x-3 gap-y-1 text-muted small" style={{ fontSize: '12px' }}>
                        <span><i className="bi bi-person me-1"></i><b>By:</b> {r.uploader_name}</span>
                        <span><i className="bi bi-calendar me-1"></i><b>Date:</b> {r.created_at}</span>
                        <span><i className="bi bi-calendar2 me-1"></i><b>Year:</b> {r.year}</span>
                        <span className={r.expire_on !== "0000-00-00" && moment(r.expire_on).isBefore(moment()) ? "text-danger fw-bold" : ""}>
                          <i className="bi bi-hourglass-end me-1"></i><b>Expires:</b> {r.expire_on === "0000-00-00" ? "No Expiry date" : r.expire_on}
                        </span>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-2 mt-sm-0 flex-shrink-0">
                      {r.ftype === 'file' && (
                        <Button 
                          variant="outline-secondary" 
                          size="sm" 
                          className="d-flex align-items-center justify-content-center p-2"
                          onClick={() => setViewDoc(Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`))} 
                          style={{ borderRadius: '8px', width: '36px', height: '36px' }}
                          title="View"
                        >
                          <i className="bi bi-eye" style={{ fontSize: '16px' }}></i>
                        </Button>
                      )}
                      {r.ftype === 'content' && (
                        <Button 
                          variant="outline-secondary" 
                          size="sm" 
                          className="d-flex align-items-center justify-content-center p-2"
                          onClick={() => printContent(r.udoc, r.content, false)} 
                          style={{ borderRadius: '8px', width: '36px', height: '36px' }}
                          title="View"
                        >
                          <i className="bi bi-eye" style={{ fontSize: '16px' }}></i>
                        </Button>
                      )}

                      {/* Download/Print Action */}
                      {r.ftype === 'file' && (
                        <a 
                          target="_blank" 
                          href={Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`)} 
                          rel="noreferrer"
                          className="btn btn-outline-secondary btn-sm d-flex align-items-center justify-content-center p-2"
                          style={{ borderRadius: '8px', width: '36px', height: '36px' }}
                          title="Download"
                        >
                          <i className="bi bi-download" style={{ fontSize: '16px' }}></i>
                        </a>
                      )}
                      {r.ftype === 'content' && (
                        <Button 
                          variant="outline-secondary" 
                          size="sm" 
                          className="d-flex align-items-center justify-content-center p-2"
                          onClick={() => printContent(r.udoc, r.content, true)} 
                          style={{ borderRadius: '8px', width: '36px', height: '36px' }}
                          title="Print"
                        >
                          <i className="bi bi-printer" style={{ fontSize: '16px' }}></i>
                        </Button>
                      )}

                      {/* Delete Action */}
                      <Button 
                        variant="outline-danger" 
                        size="sm" 
                        className="d-flex align-items-center justify-content-center p-2"
                        title="Delete file" 
                        onClick={() => deleteudf(r)} 
                        style={{ borderRadius: '8px', width: '36px', height: '36px' }}
                      >
                        <i className="bi bi-trash" style={{ fontSize: '16px' }}></i>
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Nav variant="tabs" defaultActiveKey={ctype} onSelect={setCType}>
            <Nav.Item>
              <Nav.Link eventKey="content">Add Content</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="file">Upload File</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="ai" style={{ color: '#6610f2' }}><i className="bi bi-star-fill me-1"></i>Complete with AI</Nav.Link>
            </Nav.Item>
          </Nav>
          {ctype === 'ai' && (() => {
            const contents = contentOfUDoc(ud[0]);
            const firstContent = contents[0] || null;
            return (
              <div className="mt-2">
                {contents.length > 1 && (
                  <div className="mb-3">
                    <label className="form-label fw-bold text-muted small" style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '11px' }}>Select Template Layout for AI</label>
                    <Form.Select
                      className="shadow-sm"
                      style={{ maxWidth: 350, borderRadius: '6px' }}
                      onChange={e => {
                        const c = contents.find(x => x.id === parseInt(e.target.value));
                        setUDContent(c || false);
                      }}
                    >
                      {contents.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
                    </Form.Select>
                  </div>
                )}
                {(!udContent && !firstContent) && (
                  <Alert variant="info" className="py-2 mb-2" style={{ fontSize: 12 }}>
                    ℹ️ <strong>Note:</strong> No template layout has been added in the backend. The document will be generated in fallback checklist mode.
                  </Alert>
                )}
                <CqcAiChat
                  cqcdocId={ud[0].id}
                  contentId={parseInt(_.get(udContent, 'id', 0)) || parseInt(firstContent?.id || 0) || 0}
                  udid={parseInt(upload)}
                  title={ud[0].title}
                  settings={settings}
                  onComplete={(udf) => {
                    // Add the new file to the udocs list
                    const uploadedId = parseInt(udf.id);
                    setUDocs(prev => ({
                      ...prev,
                      userdocfiles: [
                        ...prev.userdocfiles.filter(f => parseInt(f.id) !== uploadedId),
                        udf,
                      ],
                    }));
                    setCType('content');
                    setUpload(false);
                    profileDetails(0);
                  }}
                  onClose={() => setCType('content')}
                />
              </div>
            );
          })()}
          {ctype !== 'ai' && (
            <Form onSubmit={uploadFile} className="mt-4 p-3 bg-light rounded-3" style={{ border: '1px solid #e2e8f0' }}>
              <input type="hidden" name="udid" value={upload} />
              <Row className="g-3 align-items-end">
                {/* Selector / File Upload */}
                <Col xs={12} md={4}>
                  {ctype === 'file' ? (
                    <div>
                      <label className="form-label fw-bold text-muted small" style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '11px' }}>Select File</label>
                      <Form.Control type="file" required name="udoc" className="shadow-sm" style={{ borderRadius: '6px' }} />
                    </div>
                  ) : (
                    <div>
                      <label className="form-label fw-bold text-muted small" style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '11px' }}>Select Template</label>
                      <Form.Select 
                        className="shadow-sm" 
                        name="cqcdoc_id" 
                        defaultValue={parseInt(_.get(udContent,'id',0))} 
                        required 
                        onChange={(e) => {
                          if(e.target.value!==""){
                            setUDContent({id: parseInt(e.target.value),title: e.target.selectedOptions[0].getAttribute('title'),show: false});
                          }else{
                            setUDContent(false);
                          }
                        }}
                        style={{ borderRadius: '6px' }}
                      >
                        <option value="">Choose Template...</option>
                        {_.map(contentOfUDoc(ud[0]), c => <option key={c.id} value={c.id} title={c.title}>{c.title}</option>)}
                      </Form.Select>
                    </div>
                  )}
                </Col>

                {/* Edit/Update button for Content template */}
                {ctype === 'content' && _.get(udContent,'id',0) > 0 && (
                  <Col xs={12} md={3}>
                    <Button 
                      type="button" 
                      variant="info" 
                      className="w-100 text-white fw-bold shadow-sm" 
                      onClick={() => setUDContent({...udContent,mode:'edit',show:true})}
                      style={{ borderRadius: '6px', minHeight: '38px' }}
                    >
                      <i className="bi bi-pencil me-2"></i>Edit Template Content
                    </Button>
                  </Col>
                )}

                {/* Form fields once file/content is selected/ready */}
                {(ctype==='file' || contentready!==false) && (
                  <>
                    <input type="hidden" name="cqcdoc_id" value={udContent.id} />
                    <input type="hidden" name="title" value={udContent.title} />
                    <textarea className="d-none" name="content" defaultValue={contentready}></textarea>
                    
                    {/* Year Select */}
                    <Col xs={6} md={2}>
                      <div>
                        <label className="form-label fw-bold text-muted small" style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '11px' }}>Year</label>
                        <Form.Select className="shadow-sm" name="year" required defaultValue={new Date().getFullYear()} style={{ borderRadius: '6px' }}>
                          {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                          ))}
                        </Form.Select>
                      </div>
                    </Col>

                    {/* Expiry Date */}
                    {settings.flag == 3 && (
                      <Col xs={6} md={3}>
                        <div>
                          <label className="form-label fw-bold text-muted small" style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '11px' }}>Expiry Date</label>
                          <Form.Control
                            type="date"
                            name="exp_date"
                            className="shadow-sm"
                            onKeyDown={(e) => e.preventDefault()}
                            style={{ borderRadius: '6px' }}
                          />
                        </div>
                      </Col>
                    )}

                    {/* Submit Button */}
                    <Col xs={12} md={settings.flag == 3 ? 2 : 3}>
                      <Button variant="primary" type="submit" className="w-100 fw-bold shadow-sm" style={{ borderRadius: '6px', minHeight: '38px' }}>
                        <i className="bi bi-upload me-2"></i>Upload
                      </Button>
                    </Col>
                  </>
                )}
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  const showTrail = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(trail));
    // let ud =  _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setTrail(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Document Trail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Uploaded By</td>
                <td>Upload On</td>
                <td>Upload Year</td>
                <td>Expires On</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>
                    {r.udoc.replace('(AI Generated)', '').replace('(Scan Uploaded)', '').trim()}
                    {r.udoc.includes('(AI Generated)') && (
                      <span className="badge bg-success ms-2" style={{ fontSize: '10px' }}><i className="bi bi-star-fill me-1" style={{ fontSize: '9px' }}></i>AI Generated</span>
                    )}
                    {r.udoc.includes('(Scan Uploaded)') && (
                      <span className="badge bg-info text-dark ms-2" style={{ fontSize: '10px' }}><i className="bi bi-star-fill me-1" style={{ fontSize: '9px' }}></i>AI Transcribed</span>
                    )}
                  </td>
                  <td>{r.uploader_name}</td>

                  <td>{r.updated_at}</td>
                  <td>{r.year}</td>
                  <td>{r.expire_on}</td>
                  {/* <td>{showStatus(r)}</td> */}
                  <td>
                    {/* <a href={Utils.apiUrl("users/downloadudf") + "/" + r.furl}> */}
                    <a target="_blank" href={Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`)} title="Download" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px', borderRadius: '8px', padding: '0' }}>
                      <i className="bi bi-download" style={{ fontSize: '16px' }}></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const assignToUser = () => {
    const cdid = assigned;
    let data = `cqcdoc_id=${cdid}&users=${assUserTemp.join(",")}`;
    setAssigning(cdid);
    setAssigned(false);
    return axios.post(Utils.apiUrl("cqcs/assignToUsers"), data, Utils.apiHeaders()).then((res) => {
      if (res.data.success) {
        let tmpuserdocs = udocs.userdocs.filter((ud) => parseInt(ud.id) !== parseInt(cdid));
        let tmp2userdocs = udocs.userdocs.find((ud) => parseInt(ud.id) === parseInt(cdid));
        if (tmp2userdocs) {
          const prevIds = (tmp2userdocs.assignedUsers || "").split(",").map((s) => s.trim()).filter(Boolean);
          const newIds = String(res.data.data || "").split(",").map((s) => s.trim()).filter(Boolean);
          const combined = Array.from(new Set([...prevIds, ...newIds])).join(",");
          tmpuserdocs = [...tmpuserdocs, { ...tmp2userdocs, assignedUsers: combined }];
        }
        setUDocs({ ...udocs, userdocs: tmpuserdocs });
        setAssigning(false);
      }
    });
  };

  const showAssigned = () => {
    let udoc = _.filter(udocs.userdocs, (ud) => parseInt(ud.id) === parseInt(assigned))[0]; //== user document we are talking about
    let assignedIds = udoc?.assignedUsers ? udoc.assignedUsers.split(",").map((s) => s.trim()).filter(Boolean) : [];
    let assUsers = braUsers.filter((ou) => assignedIds.includes(String(ou.id)) || assignedIds.includes(Number(ou.id)));
    assUsers = [...assUsers, ...braUsers.filter((ou) => assUserTemp.includes(ou.id))]; //== filter those which are selected recently
    assUsers = _.sortBy(_.uniqBy(assUsers, 'id'), ["name", "designation"]);

    let orgAssUsers = _.sortBy(
      braUsers.filter(
        (u) =>
          (u.name.toLowerCase().includes(assignedSearch.toLowerCase()) || u.designation.toLowerCase().includes(assignedSearch.toLowerCase())) &&
          assUsers.filter((au) => au.id === u.id).length === 0
      ),
      ["name", "designation"]
    ); //== those which are neither assigned nor selected

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setAssigned(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{udoc.title}: Assign Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {assUsers.length > 0 && (
            <Alert variant="info">
              <b>Assigned to users: </b>
              <br />
              {_.map(assUsers, (ou) => (
                <Badge className="bg-light text-dark p-2 py-1 mt-1 me-1" style={{ lineHeight: "20px" }}>
                  {ou.name}
                  {assUserTemp.includes(ou.id) && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="p-1 py-0 ms-2"
                      onClick={() => setAssUserTemp(_.without(assUserTemp, ou.id))}
                    >
                      <b>X</b>
                    </Button>
                  )}
                </Badge>
              ))}
              {assUserTemp.length > 0 && (
                <div className="text-end">
                  <hr />
                  <Button variant="success" onClick={assignToUser}>
                    Assign to Users - {assUserTemp.length}
                  </Button>
                </div>
              )}
            </Alert>
          )}

          <input type="text" className="form-control" placeholder="Search user" onChange={(e) => setAssignedSearch(e.currentTarget.value)} />

          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Designation</td>
                <td width="50">Add</td>
              </tr>
            </thead>
            <tbody>
              {_.map(orgAssUsers, (ou) => (
                <tr>
                  <td>{ou.name}</td>
                  <td>{ou.designation}</td>
                  <td>
                    <Button variant="success" size="sm" onClick={() => setAssUserTemp([...assUserTemp, ou.id])}>
                      Add
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const showNotesForCQC = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => showCQCNote(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Notes - {cqcNote.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {saveNote === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Saving CQC Note..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {saveNote === false && (
            <>
              <Form onSubmit={saveCQCNote}>
                <div className="d-flex">
                  <textarea name="note" required className="form-control me-2" rows={2} placeholder="Enter your Note"></textarea>
                  <div className="ms-2">
                    <Button type="submit" variant="dark">
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </>
          )}
          {cqcNote.loading === true && (
            <Alert variant="warning" className="p-3">
              <p className="loading-msg">Fetching CQC Note..</p>
              <ProgressBar variant="warning" animated now={100} />
            </Alert>
          )}
          {cqcNote.loading === false && (
            <div style={{ maxHeight: "400px", overflow: "auto" }}>
              {_.get(notes, "length", 0) === 0 && (
                <Alert variant="danger" className="p-3">
                  <p className="loading-msg">No comments found!</p>
                </Alert>
              )}
              {_.map(notes, (note) => (
                <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                  <div>
                    <div className="badge bg-light text-dark">{Utils.toLocal(note.created_at).format("HH:mm MMM DD, YY")}</div>
                  </div>
                  <div className="text-start text-dark flex-grow-1">{note.note}</div>
                  {note.user_id === userData.uid && (
                    <div className="text-end">
                      <span
                        className="clickable text-danger me-2"
                        title={`Delete this note!`}
                        onClick={() => deleteNote(note.id)}
                        style={{ fontSize: '16px', opacity: 0.7, cursor: 'pointer' }}
                      >
                        <i className="bi bi-trash" style={{ fontSize: '16px' }}></i>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  const docSummery = () => {
    const totalDocsCount = _.get(udocs, 'counts[0].total_count', 0) || (udocs.userdocs || []).length;
    const inDateCount = parseInt(_.get(udocs, 'counts[0].in_count', 0));
    const expireSoonCount = parseInt(_.get(udocs, 'counts[0].expire_soon_count', 0));
    const expireCount = parseInt(_.get(udocs, 'counts[0].expire_count', 0));
    const naCount = parseInt(_.get(udocs, 'bars.na_count', _.get(udocs, 'bars[0].na_count', 0)));

    return (
      <Row className="g-3 mb-3">
        <Col xs={6} sm={6} md={4} lg={true}>
          <div
            className="dt-card p-3 d-flex align-items-center gap-3 h-100"
            style={{ cursor: "pointer" }}
            title="View all Documents"
            onClick={() => {
              setFilter({ ...filter, st: 0, status: 0 });
              setDType(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(10, 37, 64, 0.12)",
                color: "#0A2540"
              }}
            >
              {!loading ? totalDocsCount : "..."}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Total</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={4} lg={true}>
          <div
            className="dt-card p-3 d-flex align-items-center gap-3 h-100"
            style={{ cursor: "pointer" }}
            title="View all in Date Documents"
            onClick={() => {
              setFilter({ ...filter, st: 0, status: 2 });
              setDType(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(16, 185, 129, 0.15)",
                color: "#10B981"
              }}
            >
              {!loading ? inDateCount : "..."}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>In Date</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Compliant</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={4} lg={true}>
          <div
            className="dt-card p-3 d-flex align-items-center gap-3 h-100"
            style={{ cursor: "pointer" }}
            title="View all Expire Soon Documents"
            onClick={() => {
              setFilter({ ...filter, st: 0, status: 3 });
              setDType(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(245, 158, 11, 0.15)",
                color: "#F59E0B"
              }}
            >
              {!loading ? expireSoonCount : "..."}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Expiring</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Soon</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={true}>
          <div
            className="dt-card p-3 d-flex align-items-center gap-3 h-100"
            style={{ cursor: "pointer" }}
            title="View all Expired Documents"
            onClick={() => {
              setFilter({ ...filter, st: 0, status: 4 });
              setDType(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(239, 68, 68, 0.15)",
                color: "#EF4444"
              }}
            >
              {!loading ? expireCount : "..."}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Expired</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Action Req.</div>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} md={6} lg={true}>
          <div
            className="dt-card p-3 d-flex align-items-center gap-3 h-100"
            style={{ cursor: "pointer" }}
            title="View all Not Applicable Documents"
            onClick={() => {
              setFilter({ ...filter, st: 0, status: 5 });
              setDType(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(107, 114, 128, 0.15)",
                color: "#6B7280"
              }}
            >
              {!loading ? naCount : "..."}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>N/A</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Not Applicable</div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  if (!_.get(userData, "is_cqc", false) && !Utils.hasAccess(11)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <div className="mt-4 cqc-dashboard-container">
      <style>{`
        .cqc-dashboard-container {
          font-family: 'Montserrat', sans-serif;
          color: #1e293b;
        }
        .cqc-filter-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 16px;
          margin-bottom: 12px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
        }
        .cqc-stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
          margin: 15px 0 12px 0;
        }
        .cqc-stats-card {
          transition: all 0.2s ease-in-out;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
        }
        .cqc-stats-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;
        }
        .cqc-stats-card.active {
          box-shadow: 0 0 0 2px #0ea5e9 !important;
        }
        
        /* Table Styles & Typography Fixes */
        .cqc-desktop-table .card {
          background-color: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
        }
        .cqc-desktop-table table th {
          font-size: 11.5px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding: 14px 12px !important;
          border-bottom: 2px solid #e2e8f0 !important;
        }
        .cqc-desktop-table table td {
          font-size: 14px !important;
          font-weight: 500 !important;
          padding: 14px 12px !important;
          vertical-align: middle !important;
          color: #334155 !important;
          border-bottom: 1px solid #f1f5f9 !important;
        }
        
        /* Table Button Aesthetics */
        .cqc-desktop-table table td .btn {
          font-size: 11px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
          border-radius: 8px !important;
          padding: 7px 16px !important;
          border: none !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
        }
        .cqc-desktop-table table td .btn:hover {
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
        }
        .cqc-desktop-table table td .btn-primary {
          background-color: #0ea5e9 !important;
          color: #ffffff !important;
        }
        .cqc-desktop-table table td .btn-primary:hover {
          background-color: #0284c7 !important;
        }
        .cqc-desktop-table table td .btn-light {
          background-color: #f8fafc !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
        }
        .cqc-desktop-table table td .btn-light:hover {
          background-color: #f1f5f9 !important;
          color: #1e293b !important;
        }
        
        /* CQC Gap Analysis Dropdown Styling */
        .cqc-desktop-table table td .dropdown-toggle {
          border-radius: 20px !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          padding: 7px 18px !important;
          border: none !important;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        .cqc-desktop-table table td .dropdown-toggle:hover {
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1) !important;
        }
        
        .cqc-mobile-cards {
          display: none;
        }
        
        /* Gap Analysis Status Grid - Responsive Layout */
        .cqc-gap-analysis-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
        }
        
        .cqc-mobile-cards {
          display: none;
        }
        
        /* Hide duplicate dropdown arrow - keep only custom icon */
        .cqc-gap-analysis-grid .dropdown-toggle::after {
          display: none !important;
        }
        
        /* Dropdown styling for Filter by Category */
        .dropdown-toggle::after {
          display: none !important;
        }
        
        @media (max-width: 768px) {
          .cqc-gap-analysis-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          .cqc-stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          .cqc-desktop-table {
            display: none !important;
          }
          .cqc-mobile-cards {
            display: block !important;
          }
        }
        @media (max-width: 576px) {
          .cqc-gap-analysis-grid {
            grid-template-columns: 1fr;
            gap: 8px;
          }
        }
      `}</style>
      
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="my-0">
          <b>CQC Profile</b>
        </h2>
      </div>

      {viewDoc !== false && showViewDoc()}
      {_.get(udContent,'show',false) !== false && showUDContent()}
      {docSummery()}

      {/* Unified Filter Card */}
      <div className="cqc-filter-card">
        <Form>
          <Row className="g-2 align-items-center">
            {/* Year Select */}
            <Col xs={12} md={2}>
              <Form.Select 
                className="shadow-sm"
                onChange={setYearValue} 
                value={filter.year}
                style={{ borderRadius: '8px', minHeight: '42px' }}
              >
                <option value="">Year</option>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </Form.Select>
            </Col>

            {/* Search Input */}
            <Col xs={12} md={8}>
              <Form.Control
                type="text"
                className="shadow-sm"
                placeholder="🔍 Search by Title..."
                onKeyUp={setSearchTxt}
                style={{ borderRadius: '8px', minHeight: '42px' }}
              />
            </Col>
            
            {/* Clear Button */}
            <Col xs={12} md={2}>
              <Button
                type="reset"
                variant="outline-secondary"
                className="w-100 shadow-sm"
                onClick={() => {
                  setFilter({
                    ...filter,
                    st: 0,
                    year: "",
                    status: 0,
                    txt: "",
                  });
                  setSDate(false);
                  setDType(0);
                }}
                style={{ borderRadius: '8px', minHeight: '42px' }}
              >
                Clear Filter
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      <Card border="light" className="shadow mt-5 dashboardStats">
        <Card.Body className="mx-3">
          {/* {showprof&&<div><h4 className="mb-3">
            <b>Personal Details</b>
          </h4>
          <Card style={{ backgroundColor: "#CEDDEF88" }}>
            <Card.Body className="m-2">{renderForm()}</Card.Body>
          </Card></div>} */}

          {loading && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Fetching details..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!loading && renderDocTypes()}
          <div>
            {/* <span className="mt-4" style={{ color: "red" }}>
              Note : Documents numbered in Orange are Mandatory.
              <br />
              Documents numbered in Purple are Highly Recommended.
            </span> */}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              <a href={Utils.apiUrl("cqcs/exportdata") + "/" + _.get(data, "id", "") + addFilters(0) + "&cat=" + dtype + "&gap=" + SDate}>
                <Button type="submit" variant="primary" className="  shadow-cst p-0 text-light p-2 px-5">
                  Export Data
                </Button>
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>

      {(_.get(resources.files, "length", 0) > 0 || _.get(resources.links, "length", 0) > 0) && showResources()}
      {upload && showUpload()}
      {trail && showTrail()}
      {assigned && showAssigned()}
      {cqcNote !== false && showNotesForCQC()}
          
    </div>
  );
};

export default CqcDashboard;
